import { render } from "./manage-direct-debit-deactivation.vue?vue&type=template&id=3293ed1d"
import script from "./manage-direct-debit-deactivation.vue?vue&type=script&lang=js"
export * from "./manage-direct-debit-deactivation.vue?vue&type=script&lang=js"

import "./manage-direct-debit-deactivation.vue?vue&type=style&index=0&id=3293ed1d&lang=css"
script.render = render

export default script